import { Component, Input } from '@angular/core';
import { IdentifierStatus, IdentifierStatusPresentation } from '../../../enums/identifier-status.enum';

@Component({
  selector: 'app-corporate-email-status',
  templateUrl: './corporate-email-status.component.html',
  styleUrls: ['./corporate-email-status.component.scss'],
  standalone: false
})
export class CorporateEmailStatusComponent {
  public readonly IdentifierStatus = IdentifierStatus;
  public readonly IdentifierStatusPresentation = IdentifierStatusPresentation;

  @Input()
  public status: IdentifierStatus;
}
